import React, { useEffect, useState } from "react";
import phrase1000en from "../images/1000en.png";
import phrase1000ru from "../images/1000ru.png";
import r1 from "../images/r1.jpeg";
import r2 from "../images/r2.jpeg";
import r3 from "../images/r3.jpeg";
import chatImg from "../images/chat.png";
import correctionRu from "../images/correction_ru.png";
import correctionEn from "../images/correction_en.png";
import analysisRu from "../images/analysis_ru.png";
import analysisEn from "../images/analysis_en.png";
import saved from "../images/saved.png";
import settings from "../images/settings.png";
import modes from "../images/modes.png";
import streak from "../images/streak.png";
import translation from "../images/translation.png";
import stars from "../images/stars.png";

const ScreenshotCard = ({ header, subheader, image, alt }) => (
  <div className="screenshot-card">
    <div className="screenshot-header">
      <h3 className="screenshot-card-header">{header}</h3>
      <p className="screenshot-card-subheader">{subheader}</p>
    </div>
    <div className="screenshot-screenshot">
      <img src={image} alt={alt || header} />
    </div>
  </div>
);

function PrePayment({ strings, language, mixpanel, setShowPaymentForm }) {
  const [pageOpenTime, setPageOpenTime] = useState(Date.now());

  useEffect(() => {
    mixpanel.track("Prepayment Page Opened");
    setPageOpenTime(Date.now());
  }, []);

  const handleCtaClick = () => {
    window.Telegram.WebApp.HapticFeedback.notificationOccurred("success");
    const timeSpent = Math.floor((Date.now() - pageOpenTime) / 1000);
    mixpanel.track("Prepayment CTA Clicked", {
      timeSpentSeconds: timeSpent,
    });
    setShowPaymentForm(true);
  };

  return (
    <div className="prepayment-container">
      {/* Top header (1000 phrases in 7 days) */}
      <section className="hero-section">
        <h1 className="hero-title">{strings?.headline1000Phrases}</h1>
        <p className="hero-subtitle">{strings?.heroSubtitle}</p>
      </section>

      <div className="image-container">
        <img
          src={language === "ru" ? phrase1000ru : phrase1000en}
          alt="1000 phrases"
          className="hero-image"
        />
      </div>

      {/* Reviews (horizontal scroll) */}
      <section className="reviews-section">
        <h2>{strings?.reviewsTitle}</h2>
        <div className="reviews-container">
          {/* Example "cards" for reviews */}
          <div className="review-card">
            <h3 className="review-header">{strings?.reviewHeader1}</h3>
            <div className="review-meta">
              <div className="stars">★★★★★</div>
              <div className="reviewer-photo">
                <img src={r1} alt="Reviewer 1" />
              </div>
              <span className="reviewer-name">{strings?.reviewerName1}</span>
            </div>
            <p className="review-text">{strings?.reviewText1}</p>
          </div>

          <div className="review-card">
            <h3 className="review-header">{strings?.reviewHeader2}</h3>
            <div className="review-meta">
              <div className="stars">★★★★★</div>
              <div className="reviewer-photo">
                <img src={r2} alt="Reviewer 2" />
              </div>
              <span className="reviewer-name">{strings?.reviewerName2}</span>
            </div>
            <p className="review-text">{strings?.reviewText2}</p>
          </div>

          <div className="review-card">
            <h3 className="review-header">{strings?.reviewHeader3}</h3>
            <div className="review-meta">
              <div className="stars">★★★★★</div>
              <div className="reviewer-photo">
                <img src={r3} alt="Reviewer 3" />
              </div>
              <span className="reviewer-name">{strings?.reviewerName3}</span>
            </div>
            <p className="review-text">{strings?.reviewText3}</p>
          </div>
        </div>
      </section>

      {/* Build speaking screenshot */}
      <section className="screenshot-section">
        <h2>{strings?.screenshotTitle}</h2>
        <div className="screenshot-cards-container">
          <ScreenshotCard
            header={strings?.realConversations}
            subheader={strings?.practiceSubheader}
            image={chatImg}
          />
          <ScreenshotCard
            header={strings?.pronunciationCoach}
            subheader={strings?.soundNative}
            image={language === "ru" ? correctionRu : correctionEn}
          />
          <ScreenshotCard
            header={strings?.instantFeedback}
            subheader={strings?.learnMistakes}
            image={language === "ru" ? analysisRu : analysisEn}
          />
          <ScreenshotCard
            header={strings?.learningModes}
            subheader={strings?.differentWaysToLearn}
            image={modes}
          />
          <ScreenshotCard
            header={strings?.personalSettings}
            subheader={strings?.customizeExperience}
            image={settings}
          />
          <ScreenshotCard
            header={strings?.streakTracking}
            subheader={strings?.stayConsistent}
            image={streak}
          />
          <ScreenshotCard
            header={strings?.translation}
            subheader={strings?.understandEverything}
            image={translation}
          />
          <ScreenshotCard
            header={strings?.savedConversations}
            subheader={strings?.reviewProgress}
            image={saved}
          />
          <ScreenshotCard
            header={strings?.achievements}
            subheader={strings?.trackProgress}
            image={stars}
          />
        </div>
      </section>

      {/* Premium features section */}
      <section className="premium-section">
        <div className="premium-badge">
          <span className="crown-icon">👑</span> {strings?.chattyUnlimited}
        </div>
        <ul className="premium-features-list">
          <li>
            <span className="feature-icon">🔊</span>
            <span className="feature-text">{strings?.advancedCurriculum}</span>
          </li>
          <li>
            <span className="feature-icon">🔧</span>
            <span className="feature-text">{strings?.mistakesLessons}</span>
          </li>
          <li>
            <span className="feature-icon">📚</span>
            <span className="feature-text">{strings?.vocabularyInterests}</span>
          </li>
          <li>
            <span className="feature-icon">💬</span>
            <span className="feature-text">
              {strings?.situationalRoleplays}
            </span>
          </li>
          <li>
            <span className="feature-icon">🗣️</span>
            <span className="feature-text">
              {strings?.pronunciationCoaching}
            </span>
          </li>
          <li>
            <span className="feature-icon">🔮</span>
            <span className="feature-text">{strings?.customLesson}</span>
          </li>
          <li>
            <span className="feature-icon">📊</span>
            <span className="feature-text">{strings?.progressReports}</span>
          </li>
        </ul>
      </section>
      <section className="hero-section-footer">
        <h1 className="hero-title-black">
          {strings?.joinOver}
          <span className="highlight">20 {strings?.userCount}</span>
          {strings?.usersLearnChatty}
        </h1>
      </section>

      {/* Spacer to prevent content from being hidden behind fixed button */}
      <div className="button-spacer"></div>

      {/* The single button (always visible at the bottom) */}
      <div className="button-container">
        <button onClick={handleCtaClick} className="bottom-button">
          {strings?.prePaymentCtaButton}
        </button>
      </div>

      {/* --- STYLES --- */}
      <style jsx>{`
        .prepayment-container {
          padding: 0 16px;
          padding-bottom: 100px;
          color: var(--tg-theme-text-color);
          background-color: var(--tg-theme-bg-color);
          position: relative;
          overflow-y: auto;
          height: 100%;
        }
        .hero-title-black {
          font-size: 22px;
          font-weight: bold;
          margin: 0;
          color: var(--tg-theme-text-color);
        }
        .highlight {
          background: linear-gradient(190deg, #0390e8, #8a2be2);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .screenshot-header {
          height: 100px;
        }

        section {
          margin: 28px 0;
          padding: 16px;
          border-radius: 12px;
          background-color: var(--tg-theme-bg-color);
          overflow-y: hidden;
        }

        .hero-section {
          text-align: center;
          margin-top: 24px;
          padding-top: 0;
        }

        .hero-title {
          font-size: 28px;
          font-weight: bold;
          margin: 0;
          background: linear-gradient(190deg, #0390e8, #8a2be2);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .hero-subtitle {
          font-size: 16px;
          color: var(--tg-theme-hint-color);
          margin: 8px 0 0;
        }

        .screenshot-section {
          text-align: center;
          padding: 16px 0;
        }

        .screenshot-section h2 {
          font-size: 22px;
          margin-bottom: 16px;
        }

        .screenshot-cards-container {
          display: flex;
          overflow-x: auto;
          gap: 12px;
          padding-bottom: 8px;
          scroll-snap-type: x mandatory;
          -webkit-overflow-scrolling: touch;
        }

        .screenshot-card {
          display: flex;
          flex-direction: column;
          background: var(--tg-theme-secondary-bg-color);
          border-radius: 12px;
          padding: 8px;
          padding-top: 16px;
          padding-bottom: 0;
          width: 240px;
          height: 420px;
          flex-shrink: 0;
          scroll-snap-align: start;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
        }

        .screenshot-card-header {
          font-size: 16px;
          font-weight: 600;
          margin: 0 0 4px 0;
        }

        .screenshot-card-subheader {
          font-size: 14px;
          color: var(--tg-theme-hint-color);
          margin: 0 0 12px 0;
        }

        .screenshot-screenshot {
          flex-grow: 1;
          overflow: hidden;
          border-radius: 8px;
          display: flex;
          align-items: flex-end;
        }

        .screenshot-screenshot img {
          width: 100%;
          max-height: 100%;
          object-fit: contain;
          transform: translateY(4px);
        }

        .reviews-section {
          background-color: var(--tg-theme-bg-color);
          padding: 0;
        }

        .reviews-section h2 {
          font-size: 22px;
          text-align: center;
          margin-bottom: 16px;
        }

        .reviews-container {
          display: flex;
          overflow-x: auto;
          gap: 12px;
          padding-bottom: 8px;
          scroll-snap-type: x mandatory;
          -webkit-overflow-scrolling: touch;
        }

        .review-card {
          display: flex;
          vertical-align: top;
          flex-direction: column;
          align-items: start;
          background: var(--tg-theme-secondary-bg-color);
          border-radius: 12px;
          padding: 16px;
          width: 220px;
          flex-shrink: 0;
          scroll-snap-align: start;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
        }

        .review-header {
          margin: 0 0 8px 0;
          font-size: 16px;
          font-weight: 600;
          text-align: left;
        }

        .review-meta {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          flex-wrap: wrap;
          gap: 4px;
        }

        .review-date {
          font-size: 12px;
          color: var(--tg-theme-hint-color);
          margin-left: 4px;
        }

        .reviewer-photo {
          width: 20px;
          height: 20px;
          background-color: #ddd;
          border-radius: 50%;
          margin-left: 8px;
        }

        .reviewer-photo img {
          max-width: 100%;
          border-radius: 50%;
        }

        .reviewer-name {
          margin: 0;
          font-size: 12px;
          margin-left: 4px;
        }

        .review-text {
          font-size: 14px;
          color: var(--tg-theme-text-color);
          margin: 0;
          line-height: 1.4;
          text-align: left;
        }

        .stars {
          color: #ffbb00;
          font-size: 14px;
        }

        .premium-section {
          background: var(--tg-theme-secondary-bg-color);
          border-radius: 16px;
          padding: 20px;
          margin: 24px 0;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .premium-badge {
          background: linear-gradient(135deg, #4a6cf7, #8a2be2);
          color: white;
          display: inline-flex;
          align-items: center;
          padding: 6px 14px;
          border-radius: 16px;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 16px;
        }

        .crown-icon {
          margin-right: 6px;
        }

        .premium-features-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .premium-features-list li {
          display: flex;
          align-items: center;
          padding: 12px 0;
          border-bottom: 1px solid rgba(33, 33, 33, 0.2);
        }

        .premium-features-list li:last-child {
          border-bottom: none;
        }

        .feature-icon {
          font-size: 18px;
          margin-right: 12px;
          width: 24px;
          text-align: center;
        }

        .feature-text {
          font-size: 15px;
          text-align: start;
          line-height: 1.4;
        }

        .image-container {
          width: 100%;
          border-radius: 12px;
          margin: 16px 0;
          overflow: hidden;
        }

        .image-container img {
          width: 100%;
          display: block;
        }

        .button-container {
          position: fixed;
          left: 0;
          right: 0;
          bottom: 0;
          background: var(--tg-theme-bg-color);
          padding: 16px;
          padding-bottom: 32px;
          z-index: 998;
          border-top: 1px solid var(--tg-theme-secondary-bg-color);
          height: 50px;
          pointer-events: none;
        }

        .bottom-button {
          width: 100%;
          height: 50px;
          background: linear-gradient(135deg, #0390e8, #8a2be2);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 18px;
          font-weight: bold;
          cursor: pointer;
          z-index: 999;
          pointer-events: auto;
        }

        .bottom-button:active {
          opacity: 0.8;
        }
      `}</style>
    </div>
  );
}

export default PrePayment;
